import Vue from 'vue'
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'
import colors from 'vuetify/lib/util/colors'
import VuetifyConfirm from 'vuetify-confirm'
import IdleVue from 'idle-vue'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/title'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/dataZoomInside'
import 'echarts/lib/component/markLine'

const eventsHub = new Vue()

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
})

const vuetify = new Vuetify({
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    themes: {
      light: {
        primary: colors.blue.base,
        secondary: colors.blue.lighten4,
        accent: colors.blue.base
      },
      dark: {
        primary: '#212121',
        secondary: '#424242',
        accent: '#9e9e9e'
      },
      blue: {
        primary: '#bbdefb',
        secondary: '#64b5f6',
        accent: '#1e88e5'
      },
      green: {
        primary: '#a5d6a7',
        secondary: '#66bb6a',
        accent: '#388e3c'
      },
      red: {
        primary: '#ff5252',
        secondary: '#ff1744',
        accent: '#d50000'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})

export default vuetify

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1800000
})

Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Continuar',
  buttonFalseText: 'Cancelar',
  color: 'warning',
  icon: 'mdi-alert',
  title: 'Atención',
  width: 350,
  property: '$confirm'
})

Vue.component('v-chart', ECharts)
